import { MembershipPeriod } from './membershipPeriod';

/**
    * Organization unit membership period for a resource.
    */
export class OrganizationUnitMembershipPeriod extends MembershipPeriod{
        
}